import React, { useEffect, useState } from "react";
import {
  FaCar,
  FaMobileAlt,
  FaSimCard,
  FaLaptop,
  FaGasPump,
  FaThLarge,
  FaPlus,
  FaDownload,
} from "react-icons/fa";
import { FaSearch, FaFileExport } from "react-icons/fa";
import * as XLSX from "xlsx";
import PrimaryHeader from "../../Components/PrimaryHeader/PrimaryHeader";
import ParentComponent from "../../Components/ParentComponent/ParentComponent";
import AssetReportModal from "../../Components/AssetReportModel/AssetReportModal";
import {
  LOGOUTLOADER,
  SINGLEASSETS,
  collect,
  deleteAssets,
  getAssetsbyid,
  getAssetsdata,
  getEmployees,
  getstatsassetsmangement,
} from "../../Actions/actions";
import { useDispatch } from "react-redux";
import { BaseUrl } from "../../BaseUrl/BaseUrl";
import { useSelector } from "react-redux";
import moment from "moment/moment";
import { MdDelete, MdEdit } from "react-icons/md";
import ConfirmDeleteModal from "../../Components/ConfirmDeleteModal/ConfirmDeleteModal";
import { useNavigate } from "react-router-dom";
import { IoSend } from "react-icons/io5";
import { BsCollectionFill } from "react-icons/bs";
import AuthButton from "../../Components/AuthButton/AuthButton";
import Input from "../../Components/Input/Input";
import Loader from "../../Components/Loader/Loader";
import { AiOutlineClose } from "react-icons/ai";

const Card = ({ icon: Icon, count, label }) => (
  <div className="bg-white py-4 w-[48%] md:w-[30%] lg:w-[18%] rounded-xl shadow-md flex flex-col items-center mb-[30px]">
    {/* min-w-[160px]  */}
    <Icon className="text-red-500 w-12 h-12 mb-2" />
    <p className="xl:text-xl sm:text-lg font-public font-bold text-gray-900">
      {count}
    </p>
    <p className="xl:text-sm sm:text-xs font-public font-bold text-gray-500">
      {label}
    </p>
  </div>
);

const CardList = () => {
  const [cards, setcards] = useState([]);
  const { role, logoutLoader, loginData, activeTab, assetstatsmangement } =
    useSelector((state) => state.userReducer);
  console.log(assetstatsmangement, "data card");
  useEffect(() => {
    const Cars = assetstatsmangement.assignedAssetTypes?.find(
      (item) => item.assetType === "Cars"
    );
    const Mobiles = assetstatsmangement.assignedAssetTypes?.find(
      (item) => item.assetType === "Mobiles"
    );
    const SimCards = assetstatsmangement.assignedAssetTypes?.find(
      (item) => item.assetType === "Sim Cards"
    );
    const Laptops = assetstatsmangement.assignedAssetTypes?.find(
      (item) => item.assetType === "Laptops"
    );
    const FuelConsumption = assetstatsmangement.assignedAssetTypes?.find(
      (item) => item.assetType === "Fuel"
    );

    let asset = [
      { icon: FaCar, count: Cars?.count ? Cars?.count : 0, label: "Cars" },
      {
        icon: FaMobileAlt,
        count: Mobiles?.count ? Mobiles?.count : 0,
        label: "Mobiles",
      },
      {
        icon: FaSimCard,
        count: SimCards?.count ? SimCards?.count : 0,
        label: "Sim Cards",
      },
      {
        icon: FaLaptop,
        count: Laptops?.count ? Laptops?.count : 0,
        label: "Laptops",
      },
      {
        icon: FaGasPump,
        count: FuelConsumption?.count ? FuelConsumption?.count : 0,
        label: "Fuel Limit",
      },
    ];
    setcards(asset);
  }, [assetstatsmangement]);
  return (
    <div className="flex w-full flex-wrap justify-between  ">
      {cards.map((card, index) => (
        <Card {...card} />
      ))}
    </div>
  );
};

const TabMenu = ({ activeTab, setActiveTab, getAssets }) => {
  const tabs = [
    { label: "All", icon: FaThLarge },
    { label: "Cars", icon: FaCar },
    { label: "Mobiles", icon: FaMobileAlt },
    { label: "Sim Cards", icon: FaSimCard },
    { label: "Laptops", icon: FaLaptop },
    { label: "Fuel", icon: FaGasPump },
  ];

  const handleTabClick = (label) => {
    setActiveTab(label);
    getAssets(label);
  };
  return (
    <div className="flex flex-wrap  ">
      {tabs.map((tab, index) => (
        <button
          key={index}
          onClick={() => handleTabClick(tab.label)}
          className={`flex text-gray-400  items-center px-4 py-2 rounded-lg ${
            activeTab == tab.label ? "underline text-[grey]" : ""
          }`}
          style={{ color: activeTab == tab.label ? "black" : "gray" }}
        >
          <tab.icon className="mr-2" />
          {tab.label == "Fuel" ? "Fuel Limit" : tab.label}
        </button>
      ))}
    </div>
  );
};

const TableComponent = ({
  data,
  setEdit,
  setIsModalOpen,
  deleteid,
  setdeleteid,
  showDeleteModal,
  PrivilagesArray,
}) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [SelectedId, setSelectedId] = useState({});
  const [isMileageOpen, setIsMileageOpen] = useState(false);
  const [mileage, setMileage] = useState(0);

  const [filteredData, setFilteredData] = useState([]);
  const dispatch = useDispatch();
  const { role, logoutLoader, loginData, assetstatsmangement } = useSelector(
    (state) => state.userReducer
  );
  useEffect(() => {
    setFilteredData(data);
  }, [data]);
  useEffect(() => {
    dispatch(getstatsassetsmangement(loginData?.accessToken));
  }, []);
  const handleSearch = (e) => {
    const searchTerm = e.target?.value?.toLowerCase();
    setSearchTerm(searchTerm);
    const filtered = data?.filter(
      (item) =>
        item?.assetType?.toLowerCase()?.includes(searchTerm) ||
        item?.assetId?.toLowerCase()?.includes(searchTerm) ||
        item?.assignedEmployee.UserName?.toLowerCase()?.includes(searchTerm) ||
        item?.status?.toLowerCase()?.includes(searchTerm) ||
        item?.details?.toLowerCase()?.includes(searchTerm)
    );
    setFilteredData(filtered);
  };

  // Function to export data to Excel
  const exportToExcel = () => {
    const ws = XLSX.utils.json_to_sheet(filteredData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Asset Data");

    // Generate and trigger download of the Excel file
    XLSX.writeFile(wb, "AssetData.xlsx");
  };

  return (
    <div className="rounded-lg shadow-md bg-white relative">
      <div className="rounded-lg p-4 flex space-x-6 items-center">
        <div className="relative w-full">
          <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
          <input
            type="text"
            placeholder="Search"
            className="border border-gray-300 rounded-lg pl-10 pr-4 py-2 w-full focus:outline-none focus:ring-2 focus:ring-[#361D32]"
            value={searchTerm}
            onChange={handleSearch}
          />
        </div>

        {/* Export Button */}
        {/* <button
                    className="flex row  items-center px-4 py-2 bg-[white] text-black rounded-lg hover:underline transition"
                    onClick={exportToExcel}
                >
                    <FaDownload className="mr-3 text-black" />

                    Export
                </button> */}
      </div>
      <div className="overflow-x-auto">
        <div className="min-w-full inline-block align-middle">
          <div className="bg-white shadow-md rounded-lg overflow-hidden">
            <table className="min-w-full text-left">
              <thead className="bg-[#361D3214]">
                <tr className="text-gray-500 text-sm">
                  <th className="px-4 py-4 text-sm font-semibold text-gray-600 min-w-[140px]">
                    Asset Type
                  </th>
                  <th className="px-4 py-4 text-sm font-semibold text-gray-600 min-w-[140px] text-center">
                    Asset ID
                  </th>
                  <th className="px-4 py-4 text-sm font-semibold text-gray-600 min-w-[150px]">
                    Assigned To
                  </th>
                  <th className="px-4 py-4 text-sm font-semibold text-gray-600 min-w-[120px] text-center">
                    Status
                  </th>
                  <th className="px-4 py-4 text-sm font-semibold text-gray-600 min-w-[170px] text-center">
                    Date of Allocation
                  </th>
                  <th className="px-4 py-4 text-sm font-semibold text-gray-600 min-w-[170px] text-center">
                    Date of Expiration
                  </th>
                  {/* <th className="px-4 py-4 text-sm font-semibold text-gray-600 min-w-[350px] text-center">Usage Details</th> */}
                  <th className="py-4 px-4 text-gray-500 font-semibold text-sm min-w-[150px] text-center">
                    Action
                  </th>
                  <th className="py-4 px-4 text-gray-500 font-semibold text-sm min-w-[150px] text-center">
                    {/* Action */}
                  </th>
                </tr>
              </thead>
              <tbody className="text-sm text-gray-800">
                {filteredData?.length > 0 ? (
                  filteredData?.map((item, index) => (
                    <tr key={index} className="border-t">
                      <td className="px-4 py-3">
                        {item?.assetType == "Cars"
                          ? "Car"
                          : item?.assetType == "Mobiles"
                          ? "Mobile"
                          : item?.assetType == "Sim Cards"
                          ? "Sim Card"
                          : item?.assetType == "Laptops"
                          ? "Laptop"
                          : item?.assetType}
                      </td>
                      <td className="px-4 py-3 text-center">
                        {item?.assetType == "Fuel" ? "NA" : item?.assetId}
                      </td>
                      <td className="px-4 py-3">
                        {item?.assignedEmployee?.FullName}
                      </td>
                      <td className="px-4 py-3 text-center">
                        <span
                          className={`px-2 inline-flex text-xs leading-5 font-semibold rounded ${
                            item?.status === "Active"
                              ? "bg-green-100 text-green-800"
                              : "bg-yellow-100 text-yellow-800"
                          }`}
                        >
                          {item?.status}
                        </span>
                      </td>
                      <td className="px-4 py-3 text-center">
                        {moment(item?.startFrom).format("DD-MMM-yy")}
                      </td>
                      <td className="px-4 py-3 text-center">
                        {item?.assetType == "Fuel"
                          ? "NA"
                          : moment(item?.endTo).format("DD-MMM-yy")}
                      </td>
                      {/* <td className="px-4 py-3 text-center">{item?.task}</td> */}
                      <td className="py-3 flex gap-3 justify-center">
                        {PrivilagesArray?.length > 0 ? (
                          PrivilagesArray[0].accessLevel !== "View Only" ? (
                            <button
                              className="text-gray-600 hover:text-gray-900 bg-slate-100 w-8 h-8 flex items-center justify-center rounded-full"
                              onClick={() => {
                                dispatch(
                                  getAssetsbyid(
                                    loginData?.accessToken,
                                    item?.id,
                                    () => {
                                      setEdit(true);
                                      setIsModalOpen(true);
                                      dispatch(
                                        getstatsassetsmangement(
                                          loginData?.accessToken
                                        )
                                      );
                                    }
                                  )
                                );
                              }}
                            >
                              <MdEdit size={18} />
                            </button>
                          ) : null
                        ) : (
                          <button
                            className="text-gray-600 hover:text-gray-900 bg-slate-100 w-8 h-8 flex items-center justify-center rounded-full"
                            onClick={() => {
                              dispatch(
                                getAssetsbyid(
                                  loginData?.accessToken,
                                  item?.id,
                                  () => {
                                    setEdit(true);
                                    setIsModalOpen(true);
                                    dispatch(
                                      getstatsassetsmangement(
                                        loginData?.accessToken
                                      )
                                    );
                                  }
                                )
                              );
                            }}
                          >
                            <MdEdit size={18} />
                          </button>
                        )}
                        {PrivilagesArray?.length > 0 ? (
                          PrivilagesArray[0].accessLevel == "Full Access" ? (
                            <button
                              className="text-gray-600 hover:text-gray-900 bg-slate-100 w-8 h-8 flex items-center justify-center rounded-full"
                              onClick={() => {
                                setdeleteid(item?.id);
                                showDeleteModal(true);
                              }}
                            >
                              <MdDelete size={18} />
                            </button>
                          ) : null
                        ) : (
                          <button
                            className="text-gray-600 hover:text-gray-900 bg-slate-100 w-8 h-8 flex items-center justify-center rounded-full"
                            onClick={() => {
                              setdeleteid(item?.id);
                              showDeleteModal(true);
                            }}
                          >
                            <MdDelete size={18} />
                          </button>
                        )}
                      </td>
                      <td>
                        {item?.assetType == "Fuel" ? null : (
                          <div className="w-[90%] justify-center items-center">
                            <button
                              type="submit"
                              onClick={() => {
                                if (item?.assetType.includes("Cars")) {
                                  setIsMileageOpen(true);
                                  setSelectedId({ id: item?.id, index: index });
                                } else {
                                  dispatch(
                                    collect(
                                      loginData?.accessToken,
                                      item?.id,
                                      null,
                                      () => {
                                        const newData = [...filteredData];
                                        newData.splice(index, 1);
                                        setFilteredData([...newData]);
                                      }
                                    )
                                  );
                                }
                              }}
                              className={`w-full max-w-sm py-2 text-sm bg-[#361D32] text-white rounded-md font-semibold`}
                            >
                              Collect
                            </button>
                          </div>
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6" className="text-center py-4">
                      No results found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <MileageModal
        isOpen={isMileageOpen}
        onClose={() => {
          setIsMileageOpen(false);
        }}
        onSubmit={(value) => {
          console.log("Saved mileage:", value);
          dispatch(
            collect(loginData?.accessToken, SelectedId?.id, value, () => {
              const newData = [...filteredData];
              newData.splice(SelectedId?.index, 1);
              setFilteredData([...newData]);
            })
          );
          setIsMileageOpen(false);
        }}
        defaultMileage={mileage}
        loading={false}
      />
    </div>
  );
};

export const MileageModal = ({
  isOpen,
  onClose,
  onSubmit,
  defaultMileage = 0,
  loading = false,
}) => {
  const [mileage, setMileage] = useState(defaultMileage.toString());
  const [error, setError] = useState("");

  const handleChange = (e) => {
    const value = e.target.value;

    // ✅ Accept digits + optional 1 dot
    const isValid = /^(\d+(\.\d{0,2})?)?$/.test(value);

    if (isValid || value === "") {
      setMileage(value);
      setError("");
    } else {
      setError("Enter a valid mileage (e.g. 123.45)");
    }
  };

  const handleSave = () => {
    const numericValue = parseFloat(mileage);

    if (mileage === "" || isNaN(numericValue)) {
      setError("Please enter a valid mileage");
      return;
    }

    onSubmit(numericValue);
    setMileage("");
    setError("");
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      {/* Overlay */}
      <div
        className="bg-black opacity-40 fixed inset-0"
        onClick={() => {
          onClose();
          setMileage("");
          setError("");
        }}
      ></div>

      {/* Modal */}
      <div className="bg-white rounded-lg shadow-lg p-6 w-[90%] sm:w-[400px] relative z-10">
        <button
          className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
          onClick={() => {
            onClose();
            setMileage("");
            setError("");
          }}
        >
          <AiOutlineClose size={20} />
        </button>

        <h2 className="text-lg font-semibold mb-4">Enter Mileage</h2>

        <Input
          label="Mileage"
          name="mileage"
          type="text" // 👈 use "text" to control float input
          value={mileage}
          onChange={handleChange}
          float
          placeholder="e.g. 123.45"
        />
        {error && <p className="text-red-500 text-sm mt-1">{error}</p>}

        <div className="flex justify-end mt-6 space-x-4">
          <AuthButton
            title="Cancel"
            onClick={() => {
              onClose();
              setMileage("");
              setError("");
            }}
            className="bg-white border border-gray-300 text-gray-700 hover:bg-gray-100"
          />
          {loading ? (
            <Loader />
          ) : (
            <AuthButton
              title="Save"
              onClick={handleSave}
              className="bg-primary text-white"
            />
          )}
        </div>
      </div>
    </div>
  );
};

const AssetManagement = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { loginData, assetData, Privilages } = useSelector(
    (state) => state.userReducer
  );
  console.log(assetData, "P");
  const [activeTab, setActiveTab] = React.useState("All");
  const [searchTerm, setSearchTerm] = React.useState("");
  const [currentPage, setCurrentPage] = React.useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [change, setchange] = useState(false);
  const [allAssets, setAllAssets] = useState([]);
  const [isOpenDeleteModal, showDeleteModal] = useState(false);
  const [deleteid, setdeleteid] = useState("");
  const [edit, setEdit] = useState(false);
  const assets = [
    {
      assetType: "Car",
      assetId: "CAR001",
      assignedTo: "Ahmed Khan",
      status: "Active",
      allocationDate: "10-Nov-2024",
      usageDetails: "Mileage: 20,000 km, Insured till 2025",
    },
    {
      assetType: "Mobile Phone",
      assetId: "MOB012",
      assignedTo: "Sarah Ali",
      status: "Active",
      allocationDate: "10-Nov-2024",
      usageDetails: "Model: iPhone 13, Warranty till 2026",
    },
    {
      assetType: "SIM Card",
      assetId: "SIM045",
      assignedTo: "Ali Raza",
      status: "Active",
      allocationDate: "10-Nov-2024",
      usageDetails: "+971 50 123 4567, Monthly Plan: AED 100",
    },
    {
      assetType: "Fuel",
      assetId: "FUEL-DEC-01",
      assignedTo: "Admin Team",
      status: "Available",
      allocationDate: "10-Nov-2024",
      usageDetails: "Consumption: 150 Liters/Week",
    },
  ];

  const getAssets = (assetType) => {
    dispatch(getAssetsdata(loginData?.accessToken, assetType));
  };
  useEffect(() => {
    dispatch(getEmployees(loginData?.accessToken));
  }, []);
  useEffect(() => {
    getAssets(activeTab ? activeTab : "");
    dispatch(getstatsassetsmangement(loginData?.accessToken));
  }, [isModalOpen, change]);

  const PrivilagesArray =
    Privilages?.length > 0
      ? Privilages.filter((item) => item.feature === "User Management")
      : [];

  return (
    <ParentComponent>
      <PrimaryHeader
        PrivilagesCondition={
          PrivilagesArray?.length > 0
            ? PrivilagesArray[0].accessLevel == "Full Access"
              ? true
              : false
            : true
        }
        PrivilagesConditionAsset={
          PrivilagesArray?.length > 0
            ? PrivilagesArray[0].accessLevel == "Full Access"
              ? false
              : true
            : false
        }
        buttonText="Assign Assets"
        buttonIcon={<FaPlus className="mr-2" />}
        buttonTextfirst="Create Asset"
        onButtonClickfirst={true}
        onfirstButtonClick={() => {
          navigate("/assets-management/create-asset");
        }}
        onButtonClick={() => {
          dispatch({
            type: SINGLEASSETS,
            payload: {},
          });
          setIsModalOpen(true);
        }}
      />
      <div></div>
      <CardList />
      <TabMenu
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        getAssets={getAssets}
      />
      <TableComponent
        data={assetData}
        setEdit={setEdit}
        setIsModalOpen={setIsModalOpen}
        deleteid={deleteid}
        setdeleteid={setdeleteid}
        showDeleteModal={showDeleteModal}
        PrivilagesArray={PrivilagesArray}
      />
      <AssetReportModal
        isOpen={isModalOpen}
        onClose={() => {
          dispatch({
            type: SINGLEASSETS,
            payload: {},
          });
          setIsModalOpen(false);
          setEdit(false);
        }}
        heading={edit ? "Assign Asset" : "Assign Asset"}
        need={true}
        edit={edit}
        setEdit={setEdit}
        setchange={setchange}
        change={change}
      />
      <ConfirmDeleteModal
        isOpen={isOpenDeleteModal}
        onClose={() => {
          showDeleteModal(false);
          dispatch({
            type: SINGLEASSETS,
            payload: {},
          });
        }}
        onConfirm={() => {
          dispatch(
            deleteAssets(
              deleteid,
              () => {
                showDeleteModal(false);
                setchange(!change);
              },
              loginData?.accessToken,
              showDeleteModal
            )
          );
        }}
      />
    </ParentComponent>
  );
};

export default AssetManagement;
